/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout row wrap class="header-container pa-0 ma-0">
    <v-layout row wrap>
      <v-flex
        :class="'xs6 home-cards sm6 md'+(12/(list.length >4 ? 4 : list.length) )+' lg'+(12/(list.length >4 ? 4 : list.length))+' xl'+(12/(list.length >4 ? 4 : list.length))+''"
        v-for="(item, index) in list" :key="index">
        <Card class="header-card hoverable" :class="'card-'+((index % 4)+1)">
          <v-card-text>
            <v-flex class="pa-0 flex-card">
              <div>
                <div v-if="item != 'PR'" class="card-name subheading extraGrey--text">{{ $t(item) }} </div>
                <div v-else-if="item == 'PR'" class="card-name subheading extraGrey--text"> {{prName}} </div>
                <div class="headline font-weight-bold number--text" v-if="item == 'TOTAL PLANTS'">{{plant_count }}</div>
                <div class="headline font-weight-bold number--text" v-else-if="item == 'AC CAPACITY'">
                  {{ac_capacity | value | numberWithCommas }}<span class="card-unit extraGrey--text">
                    {{ac_capacity | unit('ac') }}</span></div>
                <div class="headline font-weight-bold number--text" v-else-if="item == 'DC CAPACITY'">
                  {{dc_capacity | value | numberWithCommas}}<span class="card-unit extraGrey--text">
                    {{dc_capacity | unit('dc') }}</span> </div>
                <div class="headline font-weight-bold number--text" v-else-if="item == 'ENERGY TODAY'">
                  {{getGeneralState('totalGeneration') | value | numberWithCommas}}<span class="card-unit extraGrey--text">
                    {{getGeneralState('totalGeneration') | unit('totalGen') }}</span></div>
                <div class="headline font-weight-bold number--text" v-else-if="item == 'CUF'">{{cuf | value }}<span
                    class="card-unit extraGrey--text"> % </span></div>
                <div class="headline font-weight-bold number--text" v-else-if="item == 'PR'">{{prValue}}<span class="card-unit extraGrey--text"> %
                  </span></div>
              </div>

              <div class="card-img" :class="'card-img-bg-'+(index+1)">
                <img v-if="item == 'TOTAL PLANTS'" src="@/assets/investment.svg" class="img-47x47" alt="">
                <img v-else-if="item == 'AC CAPACITY'" src="@/assets/plug.svg" class="img-47x47" alt="">
                <img v-else-if="item == 'DC CAPACITY'" src="@/assets/solar-panel.svg" class="img-47x47" alt="">
                <img v-else-if="item == 'ENERGY TODAY'" src="@/assets/renewable-energy.svg" class="img-47x47" alt="">
              </div>
            </v-flex>
          </v-card-text>
        </Card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import {
  mapGetters,
  mapMutations
} from 'vuex'
import {
  mixin,
  mapGettersMixin
} from '@/util/mixin/index'
import headerList from '../../services/StaticInfo.js'
import headerPR from '../../services/Home.js'
import Card from '@/components/common/Cards.vue'
var moment = require('moment')

export default {
  mixins: [ mixin, mapGettersMixin ],
  components: {
    Card
  },
  data() {
    return {
      plant_count: 0,
      ac_capacity: 0,
      dc_capacity: 0,
      list: [],
      param: {
        plantList: []
      },
      prValue: null,
      prName: '',
      prUnit: ''
    }
  },
  computed: {
    ...mapGetters([
      'getAcCapacity',
      'getDcCapacity',
      'getTotalPlantCount',
      'getGeneralState',
      'getSelectedPlantId',
      'getPlantList'
    ]),
    cuf() {
      console.log('Cuf Data : ', this.getGeneralState('totalGeneration'), this.getDcCapacity)
      return (((this.getGeneralState('totalGeneration') / this.dc_capacity) / 24) * 100).toFixed(2)
    }
  },
  mounted() {
    this.ac_capacity = this.getAcCapacity
    this.dc_capacity = this.getDcCapacity
    this.plant_count = this.getTotalPlantCount
    // this.cuf = (((this.getGeneralState('totalGeneration')/this.getDcCapacity)/24)*100).toFixed(2)
    this.getHeaderList()
    if(this.list.includes('PR'))
      this.getTotalPRPlant()
    let plantList = this.getPlantList.map(el => el.id)
    plantList.forEach(element => {
      this.param.plantList.push(element)
    })
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:MM:SS')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getHeaderList()
      if(this.list.includes('PR'))
        this.getTotalPRPlant()
    },
    async getHeaderList() {
      let response = await headerList.getHeaderInfo()
      let componentList = response.data.message
      this.list = componentList.split(',')
    },
    async getTotalPRPlant() {
      var response = await headerPR.getTotalPR(this.param)
      if (response.status == 200) {
        let headerRes = response.data.message
        this.prValue = headerRes.value
        this.prName = headerRes.name
        this.prUnit = headerRes.unit
      }
    }
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.callAllApi()
      }
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Rubik');

  .align-right {
    text-align: end;
  }

  .text-orange {
    color: orangered;
    -webkit-font-smoothing: antialiased;
  }

  .text-purple {
    color: #9866c5;
    -webkit-font-smoothing: antialiased;
  }

  .text-blue {
    color: #30c5ef;
    -webkit-font-smoothing: antialiased;
  }

  .text-green {
    color: #009688;
    -webkit-font-smoothing: antialiased;
  }

  .left-divider {
    border-right-width: 1px;
    border-right-style: solid;
    border-top-color: transparent;
    border-top-style: solid;
    border-top-width: 7px;
    border-bottom-color: transparent;
    border-bottom-style: solid;
    border-bottom-width: 7px;
  }

  .orange-divider {
    border-right-color: orangered;
  }

  .purple-divider {
    border-right-color: #9866c5;
  }

  .blue-divider {
    border-right-color: #30c5ef;
  }

  .green-divider {
    border-right-color: #009688;
  }

  .card-1 {
    /* background-color: #57A2F7; */
    /* background-image: linear-gradient(to bottom right, #00d2ff, #3a7bd5);  */
    /* background-image: linear-gradient(to bottom right, #6578E2, #6E4B9B);
}

.card-2{
  /* background-image: linear-gradient(to bottom right, #E86B9B, #E6866F); */
  }

  .card-3 {
    /* background-image: linear-gradient(to bottom right, #EEBD5A, #EFA883); */
  }

  .card-4 {
    /* background-image: linear-gradient(to bottom right, #22B9B5, #3AE68B); */
  }

  .card-value {
    font-size: 30px;
    font-family: 'Rubik', sans-serif;
  }

  .card-unit {
    font-size: 12px;
    color: lightgray;
  }

  .card-name {
    text-transform: uppercase;
  }

  /* [THEME] */
  .header-card {
    border-radius: 8px;
  }

  /* Theme */
  /* .header-container {
    height: 8.1vh;
  } */

  /* .theme--light .header-container {
  background-color: #ffffff;
  color: black;
}

.theme--dark .header-container {
  background-color: #1d2138;
} */

  /* .theme--light .header-container {
  padding-top: 0px;
}

.theme--dark .header-container {
  padding-top: 0px;
}

@media only screen and (max-width: 750px) {
  .theme--light .header-container {
    padding-top: 25px;
  }

  .theme--dark .header-container {
    padding-top: 25px;
  }
} */

  .theme--dark .left-divider {
    box-shadow: 1px 1px 5px black;
  }

  .theme--light .left-divider {
    box-shadow: 1px 1px 5px gray;
  }

  .div1 {
    flex: 1 1 auto;
    margin: 10px;
    flex-wrap: wrap;
  }

  .row {
    display: flex;
  }

  .flex-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-text {}

  .card-img {
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: grid;
    place-items: center;
  }

  .img-47x47 {
    height: 47px;
    width: 47px;
  }

  .card-img-bg-1{
background: var(--v-extraPurple-base);
box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.card-img-bg-2{
background: var(--v-extraYellow-base);
box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.card-img-bg-3{
background: var(--v-extraBlue-base);
box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.card-img-bg-4{
background: var(--v-extraRed-base);
box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
